gsap.set(".co-contact-1", { opacity: 0 });
gsap.to(".co-contact-1", {
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
// 2
gsap.set('.co-contact-2 .field', { opacity: 0, y: 10 });
gsap.to('.co-contact-2 .field', {
  scrollTrigger: {
    trigger: '.co-contact-2',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  y: 0,
  duration: 0.75,
  stagger: 0.05,
  ease: "Power4.inOut"
});
// 3
// trigger
gsap.set('.co-contact-3-frame', { y: 20, opacity: 0 });
gsap.to('.co-contact-3-frame', {
  scrollTrigger: {
    trigger: '.co-contact-3',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
// slider
const coSwiper8 = new Swiper('.co-contact-3-slider', {
  slidesPerView: "auto",
  loop: true,
  speed: 400,
  watchSlidesProgress: true,
  mousewheel: {
    forceToAxis: true,
  },
  // autoplay: {
  //       delay: 3000,
  //       // disableOnInteraction: false,
  //     },
  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },
  breakpoints: {
    0: {
      centeredSlides: true,
    },
    750: {
      centeredSlides: true,
    },
  },
});